<template>
  <button class="ui-switch"
    @click="$emit('click', !on)"
    :class="{ on, 'empty-value': onValue === ' ' && offValue === ' ' }"
    :disabled="disabled"
  >
    {{ on ? onValue : offValue }}
    <span class="circle"></span>
  </button>
</template>

<script>
export default {
  name: 'UiSwitch',
  model: {
    prop: 'on',
    event: 'click'
  },
  props: {
    on: {
      type: Boolean,
      required: true
    },
    onValue: {
      type: String,
      default: 'ON'
    },
    offValue: {
      type: String,
      default: 'OFF'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-switch {
  position: relative;
  width: 53px;
  height: 25px;
  border-radius: 12.5px;
  font-size: 12px;
  font-weight: 600;
  box-sizing: border-box;
  background-color: #d7d7d7;
  color: #fff;
  text-align: right;
  padding-right: 7px;

  &:hover {
    background-color: #b1b1b1;
  }

  &.on {
    background-color: #64b950;
    text-align: left;
    padding-left: 7px;

    .circle {
      left: auto;
      right: 3px;
    }
  }

  &[disabled] {
    opacity: 0.4;
    pointer-events: none;
    cursor: default;
  }

  .circle {
    display: inline-block;
    width: 19px;
    height: 19px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.18);
    background-color: #ffffff;
    border-radius: 50%;
    position: absolute;
    top: 3px;
    left: 3px;
  }

  &.empty-value {
    width: 35px;
  }
}
</style>
